var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none",
    fill: "#000000",
    opacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.42 0 0 0.42 12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 10.5 1.28)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(33,33,33)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-34.5, -25.28)",
    d: "M 23.697 37.56 L 24.877 37.56 C 25.717 37.56 26.508 37.168 27.016 36.499 L 34.501 26.652 L 41.986 36.499 C 42.494 37.167 43.285 37.56 44.125 37.56 L 45.305 37.56 L 35.756 25 L 44.877 13 L 43.697 13 C 42.857 13 42.066 13.392 41.558 14.061 L 34.5 23.347 L 27.441 14.06 C 26.933 13.392 26.142 13 25.302 13 L 24.122 13 L 33.243 25 L 23.697 37.56 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -11 1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(33,33,33)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-13, -25)",
    d: "M 24 26 L 24 23 C 24 16.325 18.055 11.039 11.171 12.148 C 5.812 13.011 2 17.857 2 23.284 L 2 24 L 2 26 L 2 26.142 C 2 32.695 6.777 37.928 12.868 38 C 17.96 38.06 22.256999999999998 34.656 23.575000000000003 30.001 L 22.547000000000004 30.001 C 21.927000000000003 30.001 21.365000000000006 30.356 21.096000000000004 30.914 C 19.357000000000003 34.509 15.307000000000004 36.776 10.868000000000004 35.756 C 6.776 34.815 4 30.981 4 26.783 L 4 26 L 24 26 z M 4 23.71 C 4 19.002000000000002 6.804 15.153 10.924 14.232000000000001 C 16.798 12.92 22 17.352 22 23 L 22 24 L 4 24 L 4 23.71 z",
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpress);
export default __webpack_public_path__ + "static/media/express.29d127822ca1510dacb1fcb65a907b70.svg";
export { ForwardRef as ReactComponent };